import { LeagueTabs } from './constants/leagueConstants';

// TODO refactor this to use inAppRedirect
/**
 * Redirects user to a portfolio
 * @param portfolioId which portfolio we want to redirect user to
 */
export function redirectToPortfolio(portfolioId: string): void {
  inAppRedirect(appURLs.portfolioById(portfolioId));
}

// TODO refactor this to use inAppRedirect
/**
 * Redirects user to a profile
 * @param portfolioId which profile we want to redirect user to
 */
export function redirectToProfile(profileId: string): void {
  window.$nuxt.$router.push(`/profile/${profileId}`);
}

/**
 * Redirects user to a post
 * @param postId which post we want to redirect user to
 */
export function redirectToPost(postId: string): void {
  inAppRedirect(`/${appURLs.post()}/${postId}`);
}

/**
 * Redirects the user to the specified route, while preserving their current locale.
 * Use this function only on the Nuxt client side and only for in-app navigation, as this will not handle out-of-app URLs properly
 * @param route The route to redirect to.
 * @returns {void}
 */
export function inAppRedirect(route: string | object): void {
  window.$nuxt.$router.push(window.$nuxt.localePath(route));
}

// NOTE: keep this in sync with utils/behavior/scrollBehavior.js:17
/**
 * Provides an application-level routing scheme.
 */
export const appURLs = {
  index: () => 'index',
  // TODO replace all /feed instances with this
  // TODO replace all localePath('feed') instances with this
  // TODO you can use something like the following in case localePath is used directly in the component template
  // feedUrl() {
  //   return this.localePath(appURLs.feed());
  // },
  feed: () => 'index',
  onboarding: () => 'onboarding',
  loading: () => 'loading',
  portfolio: () => 'portfolios-portfolioId',
  portfolios: () => 'portfolios',
  profile: () => 'profile',
  profileById: (id: string) => ({
    name: 'profile-profileId',
    params: { profileId: id },
  }),
  messages: () => 'messages',
  markets: () => 'markets',
  saved: () => 'saved',
  settings: () => 'settings',
  post: () => 'post',
  postById: (id: string, isMobileReply?: boolean, leagueId?: string) => ({
    name: 'post-postId',
    params: {
      postId: id,
    },
    ...((isMobileReply || leagueId) && { query: { isMobileReply, leagueId } }),
  }),
  notification_center: () => 'notifications-center',
  leagues: () => 'leagues',
  leagueById: (leagueId: string, tab?: LeagueTabs, replyId?: string) => ({
    name: 'leagues-leagueId',
    params: {
      leagueId: leagueId,
    },
    ...((tab || replyId) && { query: { tab, replyId } }),
  }),
  allLeagues: () => 'leagues/all',
  search: () => 'search',
  searchResults: () => 'searchResult',
  searchResultsByQuery: (query: string) => ({
    name: 'searchResult',
    params: {
      index: query,
    },
  }),
  searchResultsByQueryAndType: (query: string, type: string) => ({
    name: 'searchResult',
    params: {
      index: query,
    },
    query: {
      filter: type,
    },
  }),
  recommendedProfiles: () => 'profile-recommended',
  academy: () => 'academy',
  academyExplore: () => '/academy/explore',
  academyLesson: (id: string) => `/academy/lesson/${id}`,
  portfolioById: (id: string) => ({
    name: 'portfolios-portfolioId',
    params: { portfolioId: id },
  }),
  portfolioByGraphInterval: (
    graphIntervalKey: string,
    portfolioId: string
  ) => ({
    name: 'portfolios-portfolioId',
    query: {
      graphInterval: graphIntervalKey,
    },
    params: {
      portfolioId: portfolioId,
    },
  }),
};

/**
 * Query parameters for the app
 */
export const appQueryParams = {
  sideBarMenu: 'menu',
  // Profile content
  profileContent: 'profile-content',
  profileFollowers: 'followers',
  profileFollows: 'follows',
};
